import { render } from "./SelectProductsComparison.vue?vue&type=template&id=4f1dd708&scoped=true"
import script from "./SelectProductsComparison.vue?vue&type=script&lang=js"
export * from "./SelectProductsComparison.vue?vue&type=script&lang=js"

import "./SelectProductsComparison.vue?vue&type=style&index=0&id=4f1dd708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1dd708"]])

export default __exports__